import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const CreateProjectValidationSchema = () => {
  const { t } = useTranslation()

  return Yup.object().shape({
    name: Yup.string().required(t('settings.projects.errors.name')),
  })
}
